import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { SlideInAnim } from "../tools/Animations";
import { HealthSection } from "../health/HealthSection";
import { getLocalized, HealthLang, LocalizedString } from "../health/healthTypes";
import { healthCol, healthSplitLg } from "../health/healthLayout";
import {
    healthBody,
    healthSectionEyebrow,
} from "../health/healthVisualStyles";
import { EducationIntroVisual } from "./EducationIntroVisual";

interface EducationIntroSectionProps {
    data: DataKeys;
}

export function EducationIntroSection({ data }: EducationIntroSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const sectionId = "intro";
    const statementLead = getLocalized(data?.statementLead, hLang);
    const statementAccent = getLocalized(data?.statementAccent, hLang);
    const statementFallback = getLocalized(data?.statement, hLang);
    const callouts: DataKeys[] = data?.callouts ?? [];

    return (
        <HealthSection id={sectionId} ariaLabelledBy={`${sectionId}-title`} compact>
            <div className={`${healthSplitLg} lg:items-center`}>
                <div className={`${healthCol} flex min-w-0 flex-col gap-4 text-left [text-align:left]`}>
                    <p className={healthSectionEyebrow}>
                        {getLocalized(data?.eyebrow, hLang)}
                    </p>
                    <h2
                        id={`${sectionId}-title`}
                        className="max-w-[40rem] text-left text-2xl font-bold leading-snug text-grey-900 [text-align:left] lg:text-[2.25rem] lg:leading-[1.18]"
                    >
                        {statementLead && statementAccent ? (
                            <>
                                {statementLead}{" "}
                                <span className="text-teal-500">{statementAccent}</span>
                            </>
                        ) : (
                            statementFallback
                        )}
                    </h2>
                    <p className={`${healthBody} max-w-[40rem] text-grey-500`}>
                        {getLocalized(data?.body, hLang)}
                    </p>
                </div>
                <SlideInAnim direction="right" delay={0.1}>
                    <div className={`${healthCol} min-w-0`}>
                        <EducationIntroVisual
                            callouts={callouts}
                            visualAlt={data?.visualAlt as LocalizedString | undefined}
                        />
                    </div>
                </SlideInAnim>
            </div>
        </HealthSection>
    );
}
